import Repository from './Repository';
const resource = '/content/top';

export default {
  get(queryString = '') {
    return Repository.get(`${resource}${queryString}`);
  }
};
